import { type FunctionComponent } from 'react';
import { observer } from 'owa-mobx-react';
import { CopilotCommandCenterWrapper } from './CopilotCommandCenterWrapper';
import { makeStyles, mergeClasses } from '@fluentui/react-components';
import isAppPaneUnderlayExpanded from 'owa-app-pane-underlay/lib/utils/isAppPaneUnderlayExpanded';
import type { CopilotCommandCenterProps } from './CopilotCommandCenter';
import { getShouldRenderCommandCenterPlaceholder } from 'owa-copilot-command-center-store/lib/selectors/getShouldRenderCommandCenterPlaceholder';
import { shouldShowChatMenuItem } from 'owa-copilot-command-center-components/lib/utils/getShouldShowFunctions/shouldShowChatMenuItem';
import { getIsSingleLineRibbon } from '../utils/getIsSingleLineRibbon';
import { useWindow } from '@fluentui/react/lib/WindowProvider';

export const CopilotCommandCenterPlaceholder: FunctionComponent<CopilotCommandCenterProps> =
    observer((props: CopilotCommandCenterProps) => {
        const { renderingContext } = props;
        const targetWindow: Window = useWindow() ?? window;
        const isSmallScreen = targetWindow.matchMedia('(max-width: 1007px)').matches;
        const isCollapsed = isSmallScreen || isAppPaneUnderlayExpanded();

        const { placeholder, placeholderSLRLarge, placeholderSLRSmall } = useStyles();

        const wrapperStyles = mergeClasses(
            placeholder,
            getIsSingleLineRibbon(renderingContext)
                ? isCollapsed
                    ? placeholderSLRSmall
                    : placeholderSLRLarge
                : ''
        );

        return getShouldRenderCommandCenterPlaceholder() ||
            shouldShowChatMenuItem(false, targetWindow) ? (
            <CopilotCommandCenterWrapper>
                <div className={wrapperStyles} />
            </CopilotCommandCenterWrapper>
        ) : null;
    }, 'CopilotCommandCenterPlaceholder');

const useStyles = makeStyles({
    placeholder: {
        minWidth: '50px',
    },
    placeholderSLRLarge: {
        minWidth: '96px',
    },
    placeholderSLRSmall: {
        minWidth: '46px',
    },
});
